


































































































































































import { Vue, Component } from "vue-property-decorator";
import * as FocusLabel from "@/assets/scripts/FocusLabelModule";

@Component
export default class InputPage extends Vue {
  data() {
    return {
      PageTitle: "Label animation"
    };
  }
  mounted() {
    new FocusLabel.focusLabelModule();
  }
}
